import { jsx as _jsx } from "react/jsx-runtime";
import { Icon as ChakraIcon, } from '@chakra-ui/react';
import { Check } from './icons/check';
import { Plus } from './icons/plus';
import { Minus } from './icons/minus';
function getIconSize(size, isIndeterminate, isChecked) {
    if (isIndeterminate && !isChecked) {
        switch (size) {
            case 'sm':
                return '9px';
            case 'md':
            default:
                return '10px';
        }
    }
    // Other sizes apply to non indeterminate icons
    switch (size) {
        case 'sm':
            return '14px';
        case 'md':
            return '16px';
        case 'lg':
            return '18px';
        default:
            return '18px';
    }
}
export function CheckboxIcon({ variant, size, isChecked, isIndeterminate, }) {
    const shouldNotShowIcon = !isChecked && variant === 'normal' && !isIndeterminate;
    if (shouldNotShowIcon)
        return null;
    let icon;
    const iconSize = getIconSize(size, isIndeterminate, isChecked);
    switch (true) {
        case isChecked:
            icon = Check;
            break;
        case variant === 'addon':
            icon = Plus;
            break;
        case isIndeterminate:
            icon = Minus;
            break;
        default:
            icon = Check;
            break;
    }
    return _jsx(ChakraIcon, { as: icon, boxSize: iconSize });
}
//# sourceMappingURL=checkbox-icon.js.map